import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowLeftFromLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm9 6-6 6 6 6' }],
    ['path', { d: 'M3 12h14' }],
    ['path', { d: 'M21 19V5' }],
  ],
];

export default ArrowLeftFromLine;
